<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Headache Severity: </span>
      <span class="stat-stat">{{ existingEntry.data.severity / 10 }}</span>
    </div>
    <div class="stat">
      <span class="stat-label">Headache Duration: </span>
      <span class="stat-stat">{{ existingEntry.data.duration }} hours</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["existingEntry"],
};
</script>
